import React, { FC } from "react";
import { withHandle, withKey } from "../Handle/defaults";
import {
  handleOption,
  handleColors,
  handleColorsBifoldAlum,
  handleOptionWindow,
  surfaceMountColors,
} from "./defaults";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Divider,
} from "@mui/material";
import { RowLayout, ColLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import ReusableAccordian from "../ReusableAccordion";
import Choices from "../Choices";
import { Image } from "cloudinary-react";
import useAlumHandleSelector from "./useAlumHandleSelector";

const ColLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
}));

const ColLayoutLeftDivider = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  paddingBottom: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  borderRight: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  width: 200,
  marginRight: 50,
}));

const StyledDivFlex = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
});

const AlumHandle: FC = () => {
  const {
    isWindow,
    isBifold,
    handleClickWithKey,
    handleClickWithHandle,
    handleOpen,
    handleClose,
    handleChange,
    open,
    finish,
    handleStyle,
    withHandleChoice,
    withKeyChoice,
  } = useAlumHandleSelector();

  return (
    <ReusableAccordian
      accordionName="handle"
      heading="Handle Set"
      secondaryHeading="Select handle combination"
      colOrRow="col"
    >
      {withHandleChoice === "No Handle Set" && (
        <ColLayout>
          <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
            Guts Only
          </Typography>
        </ColLayout>
      )}

      {withHandleChoice === "No Handle Set" || !withHandleChoice ? (
        <RowLayout>
          {withHandle.map((state) => (
            <div
              key={state.id}
              onClick={() => handleClickWithHandle(state.label)}
            >
              <Choices
                label={state.label}
                variant={
                  state.label === withHandleChoice ? "filled" : "outlined"
                }
                checkMark={state.label === withHandleChoice}
              />
            </div>
          ))}
        </RowLayout>
      ) : (
        <>
          <ColLayout>
            <RowLayout>
              {withHandle.map((state) => (
                <div
                  key={state.id}
                  onClick={() => handleClickWithHandle(state.label)}
                >
                  <Choices
                    label={state.label}
                    variant={
                      state.label === withHandleChoice ? "filled" : "outlined"
                    }
                    checkMark={state.label === withHandleChoice}
                  />
                </div>
              ))}
            </RowLayout>
            <Divider style={{ width: "150%", margin: 10 }} />
          </ColLayout>

          <RowLayout>
            {isWindow && !isBifold ? (
              <ColLayoutSpacing>
                <Typography style={{ margin: "auto" }} variant="subtitle1">
                  Select a Handle Style
                  <span style={{ color: "red", fontSize: 22 }}>*</span>
                </Typography>

                <RowLayout>
                  <div>
                    <Choices
                      label={handleOptionWindow.label}
                      variant={
                        handleOptionWindow.label === handleStyle
                          ? "filled"
                          : "outlined"
                      }
                      checkMark={handleOptionWindow.label === handleStyle}
                      disabled={true}
                    />
                  </div>
                </RowLayout>
              </ColLayoutSpacing>
            ) : (
              <>
                <ColLayoutLeftDivider>
                  <Typography style={{ margin: "auto" }} variant="subtitle1">
                    Select a Handle Style
                    <span style={{ color: "red", fontSize: 22 }}>*</span>
                  </Typography>

                  <RowLayout>
                    <div>
                      <Choices
                        label={handleOption.label}
                        variant={
                          handleOption.label === handleStyle
                            ? "filled"
                            : "outlined"
                        }
                        checkMark={handleOption.label === handleStyle}
                        disabled={true}
                      />
                    </div>
                  </RowLayout>
                </ColLayoutLeftDivider>

                <ColLayoutSpacing>
                  <Typography variant="subtitle1">
                    With Key?
                    <span style={{ color: "red", fontSize: 22 }}>*</span>
                  </Typography>
                  <RowLayout>
                    {withKey.map((state) => (
                      <div
                        key={state.id}
                        onClick={() => handleClickWithKey(state.label)}
                      >
                        <Choices
                          label={state.label}
                          variant={
                            state.label === withKeyChoice
                              ? "filled"
                              : "outlined"
                          }
                          checkMark={state.label === withKeyChoice}
                        />
                      </div>
                    ))}
                  </RowLayout>
                </ColLayoutSpacing>
              </>
            )}
          </RowLayout>

          <StyledDivFlex>
            {handleStyle && (
              <ColLayout style={{ marginRight: 20 }}>
                <Image
                  cloudName="ag-millworks"
                  secure="true"
                  publicId={`Handles/Aluminum/${
                    isBifold
                      ? "AA_Bifold_Handle"
                      : isWindow && !finish
                      ? "surface_mount"
                      : isWindow
                      ? `surface_mount_${finish
                          ?.split(" ")
                          .join("_")
                          .toLowerCase()}`
                      : withKeyChoice === "No Key"
                      ? "touch_nokey"
                      : "touch_key"
                  }`}
                />

                <Typography style={{ paddingTop: 10 }} variant="subtitle1">
                  * All images are depicted without exterior key or handle
                  finish
                </Typography>
              </ColLayout>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <StyledFormControl variant="outlined">
                <InputLabel id="demo-controlled-open-select-label">
                  Select Finish<span style={{ color: "red" }}>*</span>
                </InputLabel>
                <Select
                  style={{ width: 250, height: 50 }}
                  labelId="demo-controlled-open-select-label"
                  id="demo-controlled-open-select"
                  label="Select Finish"
                  open={open}
                  onClose={handleClose}
                  onOpen={handleOpen}
                  value={finish}
                  onChange={handleChange}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {isWindow && !isBifold
                    ? surfaceMountColors.map((color) => (
                        <MenuItem key={color} value={color}>
                          {color}
                        </MenuItem>
                      ))
                    : isBifold
                    ? handleColorsBifoldAlum.map((color) => (
                        <MenuItem key={color} value={color}>
                          {color}
                        </MenuItem>
                      ))
                    : handleColors.map((color) => (
                        <MenuItem key={color} value={color}>
                          {color}
                        </MenuItem>
                      ))}
                </Select>
              </StyledFormControl>

              <div style={{ width: 50, height: 50, marginLeft: 40 }}>
                {finish && !isWindow && (
                  <Image
                    cloudName="ag-millworks"
                    secure="true"
                    publicId={`Handles/Aluminum/colors/${finish.replaceAll(
                      " ",
                      "_"
                    )}`}
                  />
                )}
              </div>
            </div>
          </StyledDivFlex>
        </>
      )}
    </ReusableAccordian>
  );
};

export default AlumHandle;
